import React, { useState } from 'react';
import {
    AppBar,
    Toolbar,
    Button,
    Menu,
    MenuItem,
    Hidden,
    IconButton,
} from '@mui/material';
import { Link as ScrollLink } from 'react-scroll';
import { Link as RouterLink, useNavigate} from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import { useUser } from '../../context/UserContext';
import { toast } from 'react-toastify';
import Logo from '../Logo/logo';

const Header = () => {
    const {setUser} = useUser();
    const {userData} =useUser();
    const isLoggedIn =  userData !== null ? true : false;
    const [anchorEl, setAnchorEl] = useState(null);
    const navigate = useNavigate();

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = () => {
      setUser(null);
      localStorage.removeItem("userData");
      navigate("/");
      toast.success("Successfully Logged out!", {
        position: "top-right",
        autoClose: 2000,
        ideProgressBar: true,
        closeButton: true,
      });
    };

    const handleDashboard = () => {
      navigate("/dashboard");
    };

    const menuItems = [
        { label: 'Home', to: 'home' },
        { label: 'Features', to: 'features' },
        { label: 'ESG', to: 'esg' },
        { label: 'Testimonials', to: 'testimonials' },
    ];

    return (
        <AppBar position="fixed" sx={{ backgroundColor: '#5a287d' }}>
            <Toolbar>

                <Logo isLogoLable = {true}/>

                {/* Menu icon for smaller devices */}
                <Hidden lgUp>
                    <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="menu"
                        onClick={handleMenuOpen}
                        size="large"
                    >
                        <MenuIcon />
                    </IconButton>
                </Hidden>

                {/* Desktop: Group of buttons float left */}
                <Hidden mdDown>
                    {/* <Button color="inherit" component={RouterLink} to="/" sx={{ marginRight: 2, color:'white' }}>
                        Home
                    </Button> */}
                    {menuItems.map((item) => (
                        <ScrollLink to={item.to} smooth={true} duration={500} offset={-64} >
                            <Button color="inherit" key={item.label} sx={{ marginRight: 2 ,  color: 'white'  }}>
                                {item.label}
                            </Button>
                        </ScrollLink>
                    ))}
                    <>
                        {isLoggedIn ?
                        (
                            <>
                            <Button onClick={handleDashboard}sx={{ marginRight: 2 ,  color: 'white'  }}>
                                Dashboard
                            </Button>
                            <Button onClick={handleLogout} sx={{ color: 'black', backgroundColor: '#ddcceb', '&:hover': { backgroundColor: 'white',  color: 'black',}}}>
                                Logout
                            </Button>
                            </>
                        ) : (
                            <>
                            <Button color="inherit" component={RouterLink} to="/signup" sx={{
                            color: 'black', marginRight: 2, backgroundColor: '#ddcceb', '&:hover': {
                            backgroundColor: 'white', color: 'black' }}}>
                                Signup
                            </Button>
                            <Button color="inherit" component={RouterLink} to="/login" sx={{
                            color: 'black', backgroundColor: '#ddcceb', '&:hover': {
                            backgroundColor: 'white', color: 'black'},}}>
                                Login
                            </Button>
                            </>
                        ) }
                    </>
                </Hidden>

                {/* Smaller devices: Dropdown menu */}
                <Menu
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleMenuClose}
                >
                    {menuItems.map((item) => (
                        <MenuItem key={item.label} onClick={handleMenuClose}>
                            <ScrollLink to={item.to} smooth={true} duration={500} offset={-64} sx={{ color: 'black' }}>
                                {item.label}
                            </ScrollLink>
                        </MenuItem>
                    ))}
                    <>
                        {isLoggedIn ?
                        (
                            <>
                             <MenuItem onClick={handleDashboard} sx={{ color: 'black' }}>
                                Dashboard
                            </MenuItem>
                            <MenuItem onClick={handleLogout} sx={{ color: 'black' }}>
                                Logout
                            </MenuItem>
                            </>
                        ) : (
                            <>
                            <MenuItem component={RouterLink} to="/signup" onClick={handleMenuClose} sx={{ color: 'black' }}>
                                Signup
                            </MenuItem>
                            <MenuItem component={RouterLink} to="/login" onClick={handleMenuClose} sx={{ color: 'black' }}>
                                Login
                            </MenuItem>
                            </>
                        ) }
                    </>
                </Menu>
            </Toolbar>
        </AppBar>
    );
};

export default Header;
